import { useState } from "react";
import { Check, CreditCard } from "lucide-react";
import { GREEN } from "./AgapInfo";

const pick = (code) => {
  window.dispatchEvent(new CustomEvent("agap-pick", { detail: { code } }));
  document.getElementById("agap-register")?.scrollIntoView({ behavior: "smooth", block: "start" });
};

const Card = ({ c }) => (
  <div className="bg-white border border-[#E7E7E7] p-6 flex flex-col hover:border-[#5E9420] transition-colors" data-testid={`agap-category-${c.code}`}>
    <div className="flex items-start justify-between gap-3">
      <p className="font-display text-lg font-bold leading-snug"><span style={{ color: GREEN }}>{c.code}.</span> {c.name}</p>
      {c.options.length > 0 && <span className="shrink-0 inline-flex items-center gap-1 text-[10px] overline bg-[#EEF5E4] text-[#4C7A18] px-2 py-1"><CreditCard size={11} /> Pay online</span>}
    </div>
    <p className="text-sm text-[#575757] mt-2">{c.who}</p>
    <ul className="mt-4 space-y-1.5 text-sm flex-1">{c.benefits.map((b) => <li key={b} className="flex gap-2"><Check size={14} className="shrink-0 mt-0.5" style={{ color: GREEN }} />{b}</li>)}</ul>
    <p className="mt-5 text-sm font-semibold text-[#2F343B] border-t border-[#EFEFEF] pt-4" data-testid={`agap-category-fee-${c.code}`}>{c.fee}</p>
    <button onClick={() => pick(c.code)} data-testid={`agap-category-register-${c.code}`} className="mt-4 border border-[#2F343B] hover:bg-[#2F343B] hover:text-white px-4 py-2.5 text-sm transition-colors">Register for {c.code}</button>
  </div>
);

export const AgapCategories = ({ data }) => {
  const [group, setGroup] = useState("A");
  const g = data.groups.find((x) => x.code === group);
  return (
    <section id="agap-categories" className="max-w-7xl mx-auto px-5 py-16 lg:py-24" data-testid="agap-categories">
      <div className="grid lg:grid-cols-12 gap-8 items-end">
        <div className="lg:col-span-7">
          <p className="overline" style={{ color: GREEN }}>Partner registration categories</p>
          <h2 className="font-display text-3xl sm:text-4xl font-bold mt-3 leading-tight">Register under one category, or combine several</h2>
          <p className="text-[#575757] mt-4">Indicative fees in GBP. Fixed-price items can be paid online; everything else is confirmed in your partner agreement.</p>
        </div>
        <div className="lg:col-span-5 bg-[#2F343B] text-white p-6" data-testid="agap-free-card">
          <p className="overline text-[#A6D26B]">Free · No commitment</p>
          <p className="font-display text-xl font-bold mt-2">{data.free.name}</p>
          <ul className="mt-3 space-y-1.5 text-sm text-white/80">{data.free.benefits.map((b) => <li key={b} className="flex gap-2"><Check size={14} className="shrink-0 mt-0.5 text-[#A6D26B]" />{b}</li>)}</ul>
          <button onClick={() => pick("FREE")} data-testid="agap-free-register-btn" className="mt-5 bg-[#5E9420] hover:bg-[#4C7A18] px-5 py-2.5 text-sm font-semibold transition-colors">Join free</button>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mt-12" role="tablist">
        {data.groups.map((x) => (
          <button key={x.code} onClick={() => setGroup(x.code)} data-testid={`agap-group-tab-${x.code}`}
            className={`px-4 py-2 text-sm border transition-colors ${group === x.code ? "bg-[#2F343B] text-white border-[#2F343B]" : "border-[#E7E7E7] hover:border-[#2F343B]"}`}>
            {x.code} · {x.name}
          </button>
        ))}
      </div>
      <p className="text-sm text-[#575757] mt-4" data-testid="agap-group-note">{g.note}</p>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-6">
        {data.categories.filter((c) => c.group === group).map((c) => <Card key={c.code} c={c} />)}
      </div>
    </section>
  );
};
